export const ActivityTypes = {
    EDIT: 'UPDATE',
    CREATE: 'INSERT',
    DELETE: 'DELETE',
}

export const DefaultTablePageSize = 50
export const AvailableTablePageSizes = [50, 75, 100]
